<div class="main-container">

  <div class="title">
    <span class="title-text">Establishment</span>
    <p class="small-title">
      Branch code: {{ code || '-' }}
    </p>
  </div>

  <form [formGroup]="form" class="config-form" (ngSubmit)="save()">

    <div class="field">
      <span class="field-label">Name</span>
      <input type="text" class="text-box-active" formControlName="name" />
    </div>

    <div class="field">
      <span class="field-label">Address</span>
      <input type="text" class="text-box-active" formControlName="address" />
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Landmark</span>
        <input type="text" class="text-box-active" formControlName="landmark" />
      </div>
      <div class="field">
        <span class="field-label">Location URL</span>
        <input type="text" class="text-box-active" formControlName="locationUrl" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="branch-pincode">Pincode</label>
        <div class="input-status-wrapper">
          <input
            id="branch-pincode"
            type="text"
            class="text-box-active"
            formControlName="pincode"
            inputmode="numeric"
            autocomplete="postal-code"
            maxlength="6"
            aria-describedby="branch-pincode-message"
          />
          @if(isPincodeLoading){
          <span class="lookup-spinner" aria-label="Checking pincode"></span>
          }
        </div>
        @if(pincodeControl?.touched && pincodeControl?.hasError('pattern')){
        <span id="branch-pincode-message" class="field-message field-error">
          Enter a valid 6-digit pincode.
        </span>
        } @else if(pincodeLookupMessage){
        <span
          id="branch-pincode-message"
          class="field-message"
          [class.field-error]="pincodeLookupStatus === 'error'"
          [class.field-success]="pincodeLookupStatus === 'valid'"
        >
          {{ pincodeLookupMessage }}
        </span>
        }
      </div>

      <div class="field">
        <label class="field-label" for="branch-state">State</label>
        <input
          id="branch-state"
          type="text"
          class="text-box-active readonly-field"
          formControlName="state"
          readonly
        />
      </div>

      <div class="field">
        <label class="field-label" id="branch-district-label">District</label>
        @if(districtList.length > 1){
        <mat-form-field
          class="ac-select-field"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-select
            id="branch-district"
            aria-labelledby="branch-district-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="district"
            placeholder="Select district"
            (selectionChange)="onDistrictChange()"
          >
          @for(district of districtList; track district){
          <mat-option [value]="district">{{ district }}</mat-option>
          }
          </mat-select>
        </mat-form-field>
        } @else {
        <input
          aria-labelledby="branch-district-label"
          type="text"
          class="text-box-active readonly-field"
          formControlName="district"
          readonly
        />
        }
      </div>
    </div>

    @if(canManage){
    <div class="actions">
      <button
        type="submit"
        class="ac-primary-btn"
        [disabled]="isLoading || isPincodeLoading"
      >
        Save changes
      </button>
    </div>
    }

  </form>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
